import { render, staticRenderFns } from "./TaskSelector.vue?vue&type=template&id=d386c9f6&scoped=true"
import script from "./TaskSelector.vue?vue&type=script&lang=ts"
export * from "./TaskSelector.vue?vue&type=script&lang=ts"
import style0 from "./TaskSelector.vue?vue&type=style&index=0&id=d386c9f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d386c9f6",
  null
  
)

export default component.exports